module.exports = __webpack_public_path__ + "static/img/wiseBrainIcon3.0e559b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wiseBrainIcon3.png
// module id = 8U0y
// module chunks = 1